import * as React from 'react'

const AccessRight = ({ user }) => {
  const renderFlag = (bool) =>
    bool ? (
      <i className="fas fa-check" style={{ color: 'green' }}></i>
    ) : (
      <i className="fas fa-times" style={{ color: 'red' }}></i>
    )

  return (
    <>
      <div className="mt-3">User Details:</div>
      <div className="card mt-2 p-4 w-100">
        <div className="mb-1">
          <span className="fw-bold">Full Name:&nbsp;</span>
          <p>{user.fullNameTitleize}</p>
        </div>
        <div className="mb-1">
          <span className="fw-bold">Role:&nbsp;</span>
          <p>{user.role}</p>
        </div>
        <div className="mb-1">
          <span className="fw-bold">Institution:&nbsp;</span>
          <p>{user.institution}</p>
        </div>
        <div className="mb-1">
          <span className="fw-bold">Email:&nbsp;</span>
          <p>{user.email}</p>
        </div>
        <div className="mb-1">
          <span className="fw-bold">Profession:&nbsp;</span>
          <p>{user.profession}</p>
        </div>
      </div>
      
      {/* <div className="mt-3">Event Access Rights:</div>
      <div className="card mt-2 p-4 w-100">
        <div className="mb-2">
          <span className="fw-bold">3-Day Pass:&nbsp;</span>
          {renderFlag(user.eventAccess)}
        </div>
        <div className="mb-2">
          <span className="fw-bold">WSK 1 Access:&nbsp;</span>
          {renderFlag(user.wsk1Access)}
        </div>
        <div className="mb-2">
          <span className="fw-bold">WSK 2 Access:&nbsp;</span>
          {renderFlag(user.wsk2Access)}
        </div>
        <div className="mb-2">
          <span className="fw-bold">WSK 3 Access:&nbsp;</span>
          {renderFlag(user.wsk3Access)}
        </div>
        <div className="mb-2">
          <span className="fw-bold">Day 3 Access:&nbsp;</span>
          {renderFlag(user.day3Access)}
        </div>
        <div className="mb-2">
          <span className="fw-bold">Ultrasound Workshop:&nbsp;</span>
          {renderFlag(user.ultrasound)}
        </div>
      </div>

      <div className="mt-3">Abstracts Info:</div>
      <div className="card mt-2 p-4 w-100">
        <div className="mb-1">
          <span className="fw-bold">Is Oral Presenter?&nbsp;</span>
          {renderFlag(user.isOralPresenter)}
        </div>
        <small
          className="d-block"
          dangerouslySetInnerHTML={{ __html: user.oralAbs }}
        />
        <hr />
        <div className="mb-1">
          <span className="fw-bold">Is Finalist?&nbsp;</span>
          {renderFlag(user.isFinalist)}
        </div>
        <small
          className="d-block"
          dangerouslySetInnerHTML={{ __html: user.finalistAbs }}
        />
        <div className="mt-1">
          <small>
            <strong>Award Type:</strong> {user.finalistType}
          </small>
        </div>
        <hr />
        <div className="mb-1">
          <span className="fw-bold">Is Winner?&nbsp;</span>
          {renderFlag(user.isWinner)}
        </div>
        <small
          className="d-block"
          dangerouslySetInnerHTML={{ __html: user.winnerAbs }}
        />
      </div> */}
    </>
  )
}

export default AccessRight
